import { Injectable } from '@angular/core';

@Injectable()
export class FeatureSwitchService {

	private featureSwitches = {
		darkMode: false,
	}

	constructor() {
		window['setFeatureSwitch'] = (name, value) => {
			this.set(name, value);
		};
		window['getFeatureSwitch'] = (name) => {
			return this.featureSwitches[name];
		};
	}

	// Dead code: never called anywhere in the app, and broken even if it were - `valStr` is always a
	// non-empty template literal string (there's no build-time string-replacement step in this Angular/Nx
	// setup that substitutes __PROPOOL_RELEASE_FEATURESWITCH_*__ placeholders), so `!!valStr` is always
	// true and the `.indexOf(...) === -1` guard never passes either. Left in place but undocumented-fixed
	// since "fixing" it would mean guessing at a build-time config mechanism that doesn't exist yet - see
	// TODO.md. Today, switches are only ever toggled at runtime via the window.setFeatureSwitch console hook.
	public initialize() {
		for (const key in this.featureSwitches) {
			const valStr = `__PROPOOL_RELEASE_FEATURESWITCH_${key}__`;
			const val = !!valStr;
			if (val !== undefined && valStr.indexOf('__PROPOOL_RELEASE_FEATURESWITCH_') === -1) {
				this.featureSwitches[key] = val;
			}
		}
	}

	public set(name: string, value: boolean) {
		this.featureSwitches[name] = value;
	}

	public isEnabled(name: string) {
		return this.featureSwitches[name];
	}
}
